import until from '@/api/until.js'

const RETURN_KEY = 'sale_service_return_to'

export function normalizeSaleServiceReturn(value) {
    if (!value) return ''
    let decoded = String(value).trim()
    try {
        decoded = decodeURIComponent(decoded)
    } catch (e) {
        // The value may already be decoded.
    }
    decoded = decoded.replace(/^#/, '')
    if (!decoded.startsWith('/sale_service') || decoded.startsWith('//') || decoded.includes('\\')) return ''
    try {
        const parsed = new URL(decoded, window.location.origin)
        if (parsed.origin !== window.location.origin || parsed.pathname !== '/sale_service') return ''
        const clean = new URLSearchParams()
        ;['device_sn', 'sn', 'view', 'order_id'].forEach(key => {
            const item = parsed.searchParams.get(key)
            if (item) clean.set(key, item.slice(0, 100))
        })
        const query = clean.toString()
        return `/sale_service${query ? `?${query}` : ''}`
    } catch (e) {
        return ''
    }
}

export function rememberSaleServiceReturn(value) {
    const normalized = normalizeSaleServiceReturn(value)
    if (normalized) sessionStorage.setItem(RETURN_KEY, normalized)
    return normalized
}

export function getSaleServiceReturn() {
    const fromQuery = normalizeSaleServiceReturn(until.getParameter('return_to'))
    if (fromQuery) return rememberSaleServiceReturn(fromQuery)
    return normalizeSaleServiceReturn(sessionStorage.getItem(RETURN_KEY))
}

export function finishWechatAuth(router) {
    const returnTo = getSaleServiceReturn()
    if (returnTo) {
        sessionStorage.removeItem(RETURN_KEY)
        router.replace(returnTo).catch(() => {})
        return
    }
    router.replace('/').catch(() => {})
}

export function startWechatAuth(appId, returnTo, router) {
    const safeReturn = rememberSaleServiceReturn(returnTo) || '/sale_service'
    if (process.env.NODE_ENV === 'development') {
        router.push('/login').catch(() => {})
        return
    }
    const query = `app_id=${encodeURIComponent(appId || '')}&redirect=${encodeURIComponent(safeReturn)}`
    window.location.href = `/api_nologin/login/wechat_platform/get_url?${query}`
}

// 售后页只获取用于结果通知的 OpenID，不创建账号、不登录系统。
export function startWechatOpenIdAuth(appId, returnTo) {
    const safeReturn = rememberSaleServiceReturn(returnTo) || '/sale_service'
    const query = [
        `app_id=${encodeURIComponent(appId || '')}`,
        `redirect=${encodeURIComponent(safeReturn)}`,
        'openid_only=1'
    ].join('&')
    window.location.href = `/api_nologin/login/wechat_platform/get_url?${query}`
}
